<template>
  <div class="mobile-v2-page">
    <!-- 기존 이미지 -->
    <img src="@/assets/version2/1.png" alt="" class="v2-img" />
    <img src="@/assets/version2/2.png" alt="" class="v2-img" />

    <!-- ===== 섹션 1: 가격 임팩트 ===== -->
    <section class="sec sec-price" ref="secPrice">
      <div class="sec-inner">
        <p class="price-hook">가격의 기준을 뒤집다</p>
        <p class="sec-eyebrow">분양가 상한제 적용단지 · 84타입</p>
        <div class="price-num-line">
          <span class="price-counter" :class="{ landed: priceLanded }">{{ currentPrice }}억원대</span>
        </div>
        <span class="price-from">부터</span>
        <div class="price-divider"></div>
        <p class="price-desc">수원에서 84타입 아파트를<br/><strong>6억원대</strong>에 만날 수 있는 기회,<br/>분양가 상한제이기에 가능합니다.</p>
      </div>
    </section>

    <!-- ===== 섹션 2: LTV 강조 ===== -->
    <section class="sec sec-ltv" ref="secLtv">
      <div class="sec-inner">
        <h2 class="ltv-title">수원 내 유일<br/>비규제지역</h2>
        <div class="ltv-big">
          <span class="ltv-label">LTV</span>
          <span class="ltv-num" ref="ltvCounter">0</span>
          <span class="ltv-percent">%</span>
        </div>
        <p class="ltv-desc">전매제한·거주의무 없이<br/>주택담보대출 <strong>70%</strong>까지 가능합니다.</p>
        <div class="ltv-chips">
          <span class="ltv-chip">전매제한 없음</span>
          <span class="ltv-chip">거주의무 없음</span>
          <span class="ltv-chip">LTV 70%</span>
        </div>
      </div>
    </section>

    <img src="@/assets/version2/3.png" alt="" class="v2-img" />

    <!-- ===== 관심고객등록 폼 ===== -->
    <section class="sec sec-register">
      <div class="sec-inner">
        <h2 class="reg-title">관심고객등록</h2>
        <p class="reg-desc">상담을 원하시면 아래 정보를 입력해주세요.</p>

        <div v-if="!isSubmitted">
          <form @submit.prevent="submitForm" class="reg-form">
            <div class="reg-field">
              <label>이름 <span class="req">*</span></label>
              <input type="text" v-model="formData.name" placeholder="이름을 입력해주세요" required />
            </div>
            <div class="reg-field">
              <label>연락처 <span class="req">*</span></label>
              <div class="reg-phone">
                <input type="tel" inputmode="numeric" ref="rp1" v-model="formData.phone1" placeholder="010" maxlength="3" required @input="onPhoneInput('phone1', 3, 'rp2')" />
                <span>-</span>
                <input type="tel" inputmode="numeric" ref="rp2" v-model="formData.phone2" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone2', 4, 'rp3')" />
                <span>-</span>
                <input type="tel" inputmode="numeric" ref="rp3" v-model="formData.phone3" placeholder="0000" maxlength="4" required @input="onPhoneInput('phone3', 4, null)" />
              </div>
            </div>
            <div class="reg-field">
              <label>희망 방문일시</label>
              <div class="reg-visit">
                <div class="reg-visit-wrap">
                  <svg class="reg-visit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  <input type="date" v-model="formData.visitDay" :min="today" />
                </div>
                <div class="reg-visit-wrap">
                  <svg class="reg-visit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  <select v-model="formData.visitTime">
                    <option value="">시간 선택</option>
                    <option v-for="t in timeSlots" :key="t" :value="t">{{ t }}</option>
                  </select>
                </div>
              </div>
            </div>
            <label class="reg-agree">
              <input type="checkbox" v-model="formData.agree" required />
              <span class="reg-check"></span>
              <span>개인정보 수집 및 이용에 동의합니다.</span>
            </label>
            <button type="submit" class="reg-submit" :disabled="isSubmitting">
              {{ isSubmitting ? '전송 중...' : '상담 신청하기' }}
            </button>
          </form>
        </div>

        <div v-else class="reg-success">
          <div class="reg-success-icon">✓</div>
          <h3>신청이 완료되었습니다</h3>
          <p>빠른 시일 내에 연락드리겠습니다.</p>
        </div>
      </div>
    </section>

    <!-- ===== 입지환경 ===== -->
    <section class="sec sec-location">
      <div class="sec-inner">
        <p class="sec-eyebrow">LOCATION</p>
        <h2 class="location-title">입지환경</h2>
        <img src="@/assets/introdection/location-environment1_251029.jpg" alt="입지환경" class="location-img" />
      </div>
    </section>

    <!-- ===== 동호배치도 ===== -->
    <section class="sec sec-layout">
      <div class="sec-inner">
        <p class="sec-eyebrow">LAYOUT</p>
        <h2 class="layout-title">동호배치도</h2>

        <div class="layout-tabs">
          <button class="layout-tab" :class="{ active: layoutTab === 'c3bl' }" @click="layoutTab = 'c3bl'">C3BL</button>
          <button class="layout-tab" :class="{ active: layoutTab === 'd3bl' }" @click="layoutTab = 'd3bl'">D3BL</button>
        </div>

        <transition name="fade" mode="out-in">
          <div :key="layoutTab" class="layout-img-wrap">
            <img v-if="layoutTab === 'c3bl'" src="@/assets/introdection/c3bl.jpg" alt="C3BL 동호배치도" class="layout-img" />
            <img v-else src="@/assets/introdection/d3bl.jpg" alt="D3BL 동호배치도" class="layout-img" />
          </div>
        </transition>
      </div>
    </section>

    <!-- ===== 세대정보 ===== -->
    <section class="sec sec-unit">
      <div class="sec-inner">
        <p class="sec-eyebrow">UNIT PLAN</p>
        <h2 class="unit-title">엘리프 한신더휴의<br/>세대 정보</h2>

        <div class="unit-tabs">
          <button
            v-for="tab in unitTabs"
            :key="tab.id"
            class="unit-tab"
            :class="{ active: activeUnit === tab.id }"
            @click="activeUnit = tab.id"
          >
            {{ tab.label }}
          </button>
        </div>

        <transition name="fade" mode="out-in">
          <div :key="activeUnit" class="unit-img-wrap">
            <img :src="unitImage" :alt="activeUnit" class="unit-img" />
          </div>
        </transition>
      </div>
    </section>

    <!-- ===== 커뮤니티 ===== -->
    <section class="sec sec-community">
      <div class="sec-inner">
        <p class="sec-eyebrow">COMMUNITY</p>
        <h2 class="community-title">커뮤니티</h2>

        <div class="comm-tabs">
          <button class="comm-tab" :class="{ active: communityTab === 'c3bl' }" @click="communityTab = 'c3bl'">C3BL</button>
          <button class="comm-tab" :class="{ active: communityTab === 'd3bl' }" @click="communityTab = 'd3bl'">D3BL</button>
        </div>

        <transition name="fade" mode="out-in">
          <div :key="communityTab" class="comm-img-wrap">
            <img v-if="communityTab === 'c3bl'" src="@/assets/introdection/c3blcom.jpg" alt="C3BL 커뮤니티" class="comm-img" />
            <img v-else src="@/assets/introdection/d3blcom.jpg" alt="D3BL 커뮤니티" class="comm-img" />
          </div>
        </transition>
      </div>
    </section>

    <!-- ===== 하단 관심고객등록 ===== -->
    <section class="sec sec-register sec-register-bottom">
      <div class="sec-inner">
        <h2 class="reg-title">관심고객등록</h2>
        <p class="reg-desc">상담을 원하시면 아래 정보를 입력해주세요.</p>

        <div v-if="!isSubmitted2">
          <form @submit.prevent="submitForm2" class="reg-form">
            <div class="reg-field">
              <label>이름 <span class="req">*</span></label>
              <input type="text" v-model="formData2.name" placeholder="이름을 입력해주세요" required />
            </div>
            <div class="reg-field">
              <label>연락처 <span class="req">*</span></label>
              <div class="reg-phone">
                <input type="tel" inputmode="numeric" ref="bp1" v-model="formData2.phone1" placeholder="010" maxlength="3" required @input="onPhoneInput2('phone1', 3, 'bp2')" />
                <span>-</span>
                <input type="tel" inputmode="numeric" ref="bp2" v-model="formData2.phone2" placeholder="0000" maxlength="4" required @input="onPhoneInput2('phone2', 4, 'bp3')" />
                <span>-</span>
                <input type="tel" inputmode="numeric" ref="bp3" v-model="formData2.phone3" placeholder="0000" maxlength="4" required @input="onPhoneInput2('phone3', 4, null)" />
              </div>
            </div>
            <div class="reg-field">
              <label>희망 방문일시</label>
              <div class="reg-visit">
                <div class="reg-visit-wrap">
                  <svg class="reg-visit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                  <input type="date" v-model="formData2.visitDay" :min="today" />
                </div>
                <div class="reg-visit-wrap">
                  <svg class="reg-visit-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  <select v-model="formData2.visitTime">
                    <option value="">시간 선택</option>
                    <option v-for="t in timeSlots" :key="t" :value="t">{{ t }}</option>
                  </select>
                </div>
              </div>
            </div>
            <label class="reg-agree">
              <input type="checkbox" v-model="formData2.agree" required />
              <span class="reg-check"></span>
              <span>개인정보 수집 및 이용에 동의합니다.</span>
            </label>
            <button type="submit" class="reg-submit" :disabled="isSubmitting2">
              {{ isSubmitting2 ? '전송 중...' : '상담 신청하기' }}
            </button>
          </form>
        </div>

        <div v-else class="reg-success">
          <div class="reg-success-icon">✓</div>
          <h3>신청이 완료되었습니다</h3>
          <p>빠른 시일 내에 연락드리겠습니다.</p>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import { registerCustomer } from '@/firebase/customerService'

export default {
  name: 'MobileVersion2View',
  data() {
    return {
      observers: [],
      currentPrice: 12,
      priceLanded: false,
      isSubmitting: false,
      isSubmitted: false,
      formData: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        visitDay: '',
        visitTime: '',
        agree: false
      },
      timeSlots: ['10:00', '10:30', '11:00', '11:30', '12:00', '12:30', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00'],
      isSubmitting2: false,
      isSubmitted2: false,
      formData2: {
        name: '',
        phone1: '010',
        phone2: '',
        phone3: '',
        visitDay: '',
        visitTime: '',
        agree: false
      },
      communityTab: 'c3bl',
      activeUnit: '74a',
      layoutTab: 'c3bl',
      unitTabs: [
        { id: '74a', label: '74A' },
        { id: '84a', label: '84A' },
        { id: '84b', label: '84B' },
        { id: '84c', label: '84C' },
        { id: '84d', label: '84D' },
        { id: '84e', label: '84E' },
        { id: '84p', label: '84P' },
        { id: '92a', label: '92A' },
        { id: '92b', label: '92B' },
        { id: '92c', label: '92C' },
        { id: '106a', label: '106A' },
        { id: '112a', label: '112A' },
        { id: '120pa', label: '120PA' },
        { id: '120pb', label: '120PB' }
      ]
    }
  },
  computed: {
    unitImage() {
      return require(`@/assets/unit/${this.activeUnit}.jpg`)
    }
  },
  mounted() {
    this.setupObservers()
  },
  beforeUnmount() {
    this.observers.forEach(ob => ob.disconnect())
  },
  methods: {
    setupObservers() {
      this.observe(this.$refs.secPrice, () => this.dropPrice())
      this.observe(this.$refs.secLtv, () => this.countUp(this.$refs.ltvCounter, 70, 1200))
    },
    observe(el, callback) {
      if (!el) return
      const ob = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          callback()
          ob.disconnect()
        }
      }, { threshold: 0.3 })
      ob.observe(el)
      this.observers.push(ob)
    },
    dropPrice() {
      const nums = [12, 11, 10, 9, 8, 7, 6]
      let i = 0
      this.currentPrice = nums[0]
      this.priceLanded = false
      const interval = setInterval(() => {
        i++
        if (i >= nums.length) {
          clearInterval(interval)
          this.priceLanded = true
          return
        }
        this.currentPrice = nums[i]
      }, 300)
    },
    onPhoneInput(field, maxLen, nextRef) {
      this.formData[field] = this.formData[field].replace(/[^0-9]/g, '')
      if (this.formData[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    },
    async submitForm() {
      if (!this.formData.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }
      this.isSubmitting = true
      try {
        await registerCustomer({
          name: this.formData.name,
          phone: `${this.formData.phone1}${this.formData.phone2}${this.formData.phone3}`,
          visitDate: this.formData.visitDay && this.formData.visitTime
            ? `${this.formData.visitDay} ${this.formData.visitTime}`
            : this.formData.visitDay || '',
          source: 'website_m_v2'
        })
        this.isSubmitted = true

        // 네이버 전환 스크립트 - 신청완료(lead)
        if (window.wcs) {
          if (!window.wcs_add) window.wcs_add = {}
          window.wcs_add['wa'] = 's_40bc4a03dda1'
          var _conv = {}
          _conv.type = 'lead'
          window.wcs.trans(_conv)
        }
      } catch (error) {
        console.error('등록 오류:', error)
        alert('등록 중 오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting = false
      }
    },
    onPhoneInput2(field, maxLen, nextRef) {
      this.formData2[field] = this.formData2[field].replace(/[^0-9]/g, '')
      if (this.formData2[field].length >= maxLen && nextRef) {
        this.$refs[nextRef].focus()
      }
    },
    async submitForm2() {
      if (!this.formData2.agree) {
        alert('개인정보 수집 및 이용에 동의해주세요.')
        return
      }
      this.isSubmitting2 = true
      try {
        await registerCustomer({
          name: this.formData2.name,
          phone: `${this.formData2.phone1}${this.formData2.phone2}${this.formData2.phone3}`,
          visitDate: this.formData2.visitDay && this.formData2.visitTime
            ? `${this.formData2.visitDay} ${this.formData2.visitTime}`
            : this.formData2.visitDay || '',
          source: 'website_m_v2'
        })
        this.isSubmitted2 = true

        if (window.wcs) {
          if (!window.wcs_add) window.wcs_add = {}
          window.wcs_add['wa'] = 's_40bc4a03dda1'
          var _conv = {}
          _conv.type = 'lead'
          window.wcs.trans(_conv)
        }
      } catch (error) {
        console.error('등록 오류:', error)
        alert('등록 중 오류가 발생했습니다. 다시 시도해주세요.')
      } finally {
        this.isSubmitting2 = false
      }
    },
    countUp(el, target, duration) {
      if (!el) return
      const start = performance.now()
      const step = (now) => {
        const progress = Math.min((now - start) / duration, 1)
        const eased = 1 - Math.pow(1 - progress, 3)
        const val = Math.round(eased * target)
        el.textContent = val
        if (progress < 1) requestAnimationFrame(step)
      }
      requestAnimationFrame(step)
    }
  }
}
</script>

<style scoped>
.mobile-v2-page {
  min-height: 100vh;
  min-height: 100dvh;
  background: #fff;
  padding-top: 60px;
  padding-bottom: 140px;
  overflow-x: hidden;
}

.v2-img {
  width: 100%;
  display: block;
}

.sec {
  position: relative;
}

.sec-inner {
  padding: 80px 28px;
}

.sec-eyebrow {
  font-family: 'Roboto', sans-serif;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 3px;
  text-transform: uppercase;
  color: var(--thehue-primary, #004538);
  margin-bottom: 20px;
}

/* ===== 가격 섹션 ===== */
.sec-price {
  background: #fafaf7;
  text-align: center;
}

.sec-price .sec-inner {
  padding: 80px 28px 72px;
}

.price-hook {
  font-family: 'Noto Serif KR', serif;
  font-size: 26px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 16px;
  letter-spacing: -0.5px;
}

.price-num-line {
  margin-top: 20px;
}

.price-counter {
  font-family: 'Paperlogy', sans-serif;
  font-size: 88px;
  font-weight: 900;
  color: var(--thehue-primary, #004538);
  line-height: 1;
  display: inline-block;
}

.price-counter.landed {
  animation: priceBounce 1.2s ease infinite;
}

@keyframes priceBounce {
  0%, 100% { transform: translateY(0); }
  50% { transform: translateY(-12px); }
}

.price-from {
  display: block;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 24px;
  font-weight: 600;
  color: #1a1a1a;
  margin-top: 8px;
}

.price-divider {
  width: 40px;
  height: 3px;
  background: var(--thehue-primary, #004538);
  margin: 32px auto;
  border-radius: 2px;
}

.price-desc {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 17px;
  color: #888;
  line-height: 2;
}

.price-desc strong {
  color: var(--thehue-primary, #004538);
  font-weight: 800;
}

/* ===== LTV 섹션 ===== */
.sec-ltv {
  background: var(--thehue-primary, #004538);
  text-align: center;
  overflow: hidden;
}

.ltv-badge-wrap {
  margin-bottom: 16px;
}

.ltv-badge {
  display: inline-block;
  padding: 8px 24px;
  border: 1.5px solid rgba(255,255,255,0.4);
  border-radius: 30px;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  letter-spacing: 2px;
}

.ltv-title {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 34px;
  font-weight: 800;
  color: #fff;
  margin-bottom: 28px;
  line-height: 1.3;
}

.ltv-big {
  display: flex;
  align-items: baseline;
  justify-content: center;
  gap: 4px;
  margin-bottom: 32px;
}

.ltv-label {
  font-family: 'Roboto', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: rgba(255,255,255,0.5);
}

.ltv-num {
  font-family: 'Paperlogy', sans-serif;
  font-size: 120px;
  font-weight: 900;
  color: #fff;
  line-height: 1;
}

.ltv-percent {
  font-family: 'Paperlogy', sans-serif;
  font-size: 56px;
  font-weight: 800;
  color: rgba(255,255,255,0.6);
}

.ltv-desc {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 17px;
  color: rgba(255,255,255,0.75);
  line-height: 1.8;
  margin-bottom: 32px;
}

.ltv-desc strong {
  color: #fff;
}

.ltv-chips {
  display: flex;
  justify-content: center;
  gap: 10px;
  flex-wrap: wrap;
}

.ltv-chip {
  padding: 10px 20px;
  background: rgba(255,255,255,0.12);
  border-radius: 20px;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 15px;
  font-weight: 500;
  color: #fff;
}

/* ===== 관심고객등록 섹션 ===== */
.sec-register {
  background: var(--thehue-primary, #004538);
}

.sec-register .sec-inner {
  padding: 72px 28px;
}

.sec-register .reg-title {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 24px;
  font-weight: 700;
  color: #fff;
  text-align: center;
  margin-bottom: 8px;
}

.sec-register .reg-desc {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 14px;
  color: rgba(255,255,255,0.5);
  text-align: center;
  margin-bottom: 32px;
}

.reg-form {
  max-width: 400px;
  margin: 0 auto;
}

.reg-field {
  margin-bottom: 18px;
}

.reg-field label {
  display: block;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgba(255,255,255,0.7);
  margin-bottom: 8px;
}

.req {
  color: var(--thehue-primary-light, #006652);
}

.reg-field input[type="text"],
.reg-field input[type="tel"] {
  width: 100%;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 10px;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 15px;
  color: #1a1a1a;
  outline: none;
  transition: border-color 0.2s ease;
}

.reg-field input:focus {
  border-color: #fff;
}

.reg-field input::placeholder {
  color: #bbb;
}

.reg-phone {
  display: flex;
  align-items: center;
  gap: 6px;
}

.reg-phone input {
  flex: 1;
  text-align: center;
  min-width: 0;
}

.reg-phone span {
  color: rgba(255,255,255,0.6);
  font-size: 14px;
  flex-shrink: 0;
}

.reg-visit {
  display: flex;
  gap: 8px;
}

.reg-visit-wrap {
  flex: 1;
  position: relative;
}

.reg-visit-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  color: #999;
  pointer-events: none;
  z-index: 1;
}

.reg-visit input,
.reg-visit select {
  width: 100%;
  padding: 14px 16px 14px 40px;
  background: #fff;
  border: 1px solid rgba(255,255,255,0.3);
  border-radius: 10px;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 14px;
  color: #1a1a1a;
  outline: none;
  appearance: none;
  transition: border-color 0.2s ease;
}

.reg-visit input:focus,
.reg-visit select:focus {
  border-color: #fff;
}

.reg-visit select {
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 12 12'%3E%3Cpath fill='%23999' d='M6 8L1 3h10z'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 14px center;
  padding-right: 36px;
}

.reg-agree {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 13px;
  color: rgba(255,255,255,0.6);
  margin: 24px 0 20px;
}

.reg-agree input[type="checkbox"] { display: none; }

.reg-check {
  width: 18px;
  height: 18px;
  border: 2px solid rgba(255,255,255,0.3);
  border-radius: 4px;
  position: relative;
  transition: all 0.2s ease;
  flex-shrink: 0;
}

.reg-agree input:checked + .reg-check {
  background: var(--thehue-primary, #004538);
  border-color: var(--thehue-primary, #004538);
}

.reg-agree input:checked + .reg-check::after {
  content: '';
  position: absolute;
  top: 2px;
  left: 5px;
  width: 5px;
  height: 9px;
  border: solid #fff;
  border-width: 0 2px 2px 0;
  transform: rotate(45deg);
}

.reg-submit {
  width: 100%;
  padding: 16px;
  background: #fff;
  color: var(--thehue-primary, #004538) !important;
  border: none;
  border-radius: 12px;
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 16px;
  font-weight: 700;
  color: #fff;
  cursor: pointer;
  transition: background 0.3s ease;
}

.reg-submit:active { background: #e8e8e8; }
.reg-submit:disabled { opacity: 0.6; cursor: not-allowed; }

.reg-success {
  text-align: center;
  padding: 40px 0;
}

.reg-success-icon {
  width: 56px;
  height: 56px;
  border: 2px solid var(--thehue-primary, #004538);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  color: var(--thehue-primary, #004538);
  margin: 0 auto 16px;
}

.reg-success h3 {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 18px;
  font-weight: 700;
  color: #fff;
  margin-bottom: 8px;
}

.reg-success p {
  font-size: 14px;
  color: rgba(255,255,255,0.5);
}

/* ===== 커뮤니티 섹션 ===== */
.sec-community {
  background: #fafaf7;
}

.community-title {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 32px;
}

.comm-tabs {
  display: flex;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 24px;
}

.comm-tab {
  flex: 1;
  padding: 16px 0;
  background: #999;
  border: none;
  font-family: 'Roboto', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: background 0.3s ease;
  letter-spacing: 2px;
}

.comm-tab:hover {
  background: #777;
}

.comm-tab.active {
  background: var(--thehue-primary, #004538);
}

.comm-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 세대정보 섹션 ===== */
.sec-unit {
  background: #fff;
}

.unit-title {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  line-height: 1.4;
  margin-bottom: 32px;
}

.unit-tabs {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 24px;
}

.unit-tab {
  padding: 14px 4px;
  background: #999;
  border: none;
  font-family: 'Roboto', sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: background 0.3s ease;
  letter-spacing: 0.5px;
}

.unit-tab:hover {
  background: #777;
}

.unit-tab.active {
  background: var(--thehue-primary, #004538);
}

.unit-img-wrap {
  width: 100%;
}

.unit-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 동호배치도 섹션 ===== */
.sec-layout {
  background: #fff;
}

.layout-title {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 32px;
}

.layout-tabs {
  display: flex;
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 24px;
}

.layout-tab {
  flex: 1;
  padding: 16px 0;
  background: #999;
  border: none;
  font-family: 'Roboto', sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #fff;
  cursor: pointer;
  transition: background 0.3s ease;
  letter-spacing: 2px;
}

.layout-tab:hover {
  background: #777;
}

.layout-tab.active {
  background: var(--thehue-primary, #004538);
}

.layout-img {
  width: 100%;
  height: auto;
  display: block;
}

/* ===== 입지환경 섹션 ===== */
.sec-location {
  background: #fafaf7;
}

.location-title {
  font-family: 'Noto Sans KR', sans-serif;
  font-size: 28px;
  font-weight: 700;
  color: #1a1a1a;
  margin-bottom: 32px;
}

.location-img {
  width: 100%;
  height: auto;
  display: block;
}


.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
